var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"clickable fancyborder dismiss",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("X")])}
var staticRenderFns = []

export { render, staticRenderFns }